import './sass/contact.scss';
import { motion } from "framer-motion";
import { getSectionAnimation } from '../animations/sections';

function Contact() {
  return (
  <motion.section id="contact" className="contact" {...getSectionAnimation}>
      <h2 className="heading overline">What's Next?</h2>
      <h2 className="title">Get In Touch</h2>
      <p>
      I'm actively exploring new opportunities in tech, and my inbox is ready to receive your messages.
      Whether you have a question or simply want to say hello, I'm always here to connect with you!
      </p>
      <a className="email-link" href="mailto:aryamanz29@gmail.com">
        Say Hello
      </a>
  </motion.section>
  );
}
export default Contact;
